var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container row"},[_c('div',{staticClass:"main",on:{"click":_vm.goTo}},[_vm._v("京ICP备18009005号-6")])])
}
var staticRenderFns = []

export { render, staticRenderFns }